(function () {
  'use strict';

  function headerScroll() {
    function onScroll() {
      document.documentElement.classList.toggle('mmb-stuck', window.scrollY > 60);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Publish the header's real height so the hero can sit underneath it.
  function measureHeader() {
    // measure the header row only — the announcement bar above it stays
    // in flow as a visible strip, so the hero must not tuck under it.
    // Measure the SECTION WRAPPER, not the inner bar. Shopify wraps every
    // section in .shopify-section, which can carry its own padding; measuring
    // only the inner div leaves that strip uncovered by the hero.
    var bar = document.querySelector('[data-mmb-topbar]');
    var group = (bar && bar.closest('.shopify-section')) || bar
             || document.querySelector('.header-wrapper')
             || document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    var lastH = null;
    function set() {
      var h = group.offsetHeight;
      // Only write when the value actually changes. Writing unconditionally
      // re-triggers layout, which refires the ResizeObserver -> feedback loop.
      if (h && h !== lastH) {
        lastH = h;
        document.documentElement.style.setProperty('--mmb-header-h', h + 'px');
      }
    }
    set();
    window.addEventListener('resize', set);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        // rAF defers the read out of the observer callback, which is what
        // browsers flag as "ResizeObserver loop limit exceeded".
        window.requestAnimationFrame(set);
      });
      ro.observe(group);
    }
    window.addEventListener('load', set);
  }

  var carouselCleanup = new Map();

  function carousels() {
    document.querySelectorAll('[data-mmb-car]').forEach(function (wrap) {
      if (carouselCleanup.has(wrap)) return;
      var track = wrap.querySelector('[data-mmb-track]');
      var prev = wrap.querySelector('[data-mmb-prev]');
      var next = wrap.querySelector('[data-mmb-next]');
      if (!track) return;
      function step() {
        var c = track.querySelector('[data-mmb-item]');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function sync() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      carouselCleanup.set(wrap, function () { window.removeEventListener('resize', sync); });
      sync();
    });
  }

  var videos = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection;

  function syncVideo(video, state) {
    if (!state.visible || document.hidden || reducedMotion.matches || (connection && connection.saveData)) {
      video.pause();
      return;
    }
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }

  var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
      syncVideo(entry.target, state);
    });
  }, { threshold: [0, 0.1] }) : null;

  function syncVideos() {
    videos.forEach(function (state, video) { syncVideo(video, state); });
  }

  function heroVideo() {
    document.querySelectorAll('[data-mmb-hero-video] video').forEach(function (video) {
      if (videos.has(video)) return;
      video.autoplay = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      var state = { visible: !videoObserver };
      videos.set(video, state);
      if (videoObserver) videoObserver.observe(video);
      syncVideo(video, state);
    });
  }

  document.addEventListener('visibilitychange', syncVideos);
  reducedMotion.addEventListener('change', syncVideos);
  if (connection) connection.addEventListener('change', syncVideos);
  document.addEventListener('shopify:section:unload', function (event) {
    videos.forEach(function (state, video) {
      if (!event.target.contains(video)) return;
      video.pause();
      if (videoObserver) videoObserver.unobserve(video);
      videos.delete(video);
    });
    carouselCleanup.forEach(function (cleanup, wrap) {
      if (!event.target.contains(wrap)) return;
      cleanup();
      carouselCleanup.delete(wrap);
    });
  });

  function init() { headerScroll(); measureHeader(); carousels(); heroVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', function () { carousels(); heroVideo(); });
})();

